import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const UserIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 23.9)}
      {...svgProps}
      viewBox="0 0 18.9 23.9"
    >
      <g
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        transform="translate(6.28 4.52)"
      >
        <circle cx="3.2" cy=".8" r="4.3" />
        <path d="m-5.3 18.4v-2.4c0-3.5 2.8-6.4 6.4-6.4h4.2c3.5 0 6.4 2.8 6.4 6.4v2.4" />
      </g>
    </SVG>
  );
};
